export default __webpack_public_path__ + "static/media/lotus.11eac64b.png";